import firebase from 'firebase/app';
import 'firebase/firestore'
import 'firebase/auth'

// firebase init goes here
const config = {
    apiKey: "AIzaSyAJjoK9nWMIruz4yaeUkvzFpPyC351uXFU",
    authDomain: "code-clans-for-dev-dont-delete.firebaseapp.com",
    databaseURL: "https://code-clans-for-dev-dont-delete.firebaseio.com",
    projectId: "code-clans-for-dev-dont-delete",
    storageBucket: "code-clans-for-dev-dont-delete.appspot.com",
    messagingSenderId: "339414857886",
    appId: "1:339414857886:web:c78c54b202167e924ee38f"
}
// console.log(firebase.apps)
if(firebase.apps.length ===  0){
    firebase.initializeApp(config)
}

// const  lengthApp =firebase.apps
// // firebase utils

const db = firebase.firestore()


// const auth = firebase.auth()
// const currentUser = auth.currentUser
//
let ordersCollection = db.collection('orders')

export {
    // firebase,
    // auth,
    // currentUser,
    ordersCollection,
    db,
}